import React, { Component } from 'react';
import { connect } from "react-redux";
import {addSamplePack} from 'actions/index.js';
import SamplePack from 'repos/SamplePack.js';
import SamplePacksListComponent from 'components/SamplePacksListComponent.js';
import PaletteSamplePackComponent from 'components/palette/PaletteSamplePackComponent.js';

import '../../Palette.css';

class PaletteComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showSamplePacks: true,
            showPalette: true,
        };
    }

    onClickPaletteButton() {
        this.setState({showPalette: !this.state.showPalette});
    }

    onClickSamplePacksButton() {
        this.setState({showSamplePacks: !this.state.showSamplePacks});
    }

    render() {
        return (
            <div className="palette-container">
              <div
                onClick={() => this.onClickPaletteButton()}
                className="palette-sub-header">
                YOUR PALETTE 
                </div>
                <div className="info-text">Drag to track</div>
                {this.state.showPalette ? 
              this.props.palette.map(
                  (samplePack, i) =>
                      <PaletteSamplePackComponent
                        key={samplePack.id}
                        samplePack={samplePack}/>) : ''}
                                                             

                <div
                  onClick={() => this.onClickSamplePacksButton()}
                  className="palette-sub-header">
                SAMPLE PACKS
                </div>
                {this.state.showSamplePacks ? 
                <SamplePacksListComponent
                 onClickSamplePack={(s) => this.props.addSamplePack(s)}/> : ''}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        palette: Object.values(state.palette)
            .map(p => {
                let samplePack = new SamplePack();
                samplePack.fromJson(p);
                return samplePack;
            })
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addSamplePack : samplePack => dispatch(addSamplePack(samplePack)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaletteComponent);
